import {
  Component,
  OnInit,
  Optional,
  Inject,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  DestroyRef,
  RESPONSE_INIT
} from '@angular/core';
import { PlatformInformationService } from '../../../../../projects/platform-manager/src/public_api';

import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { startWith } from 'rxjs';
import { AlpitranslatePipe } from '../../../core/pipes/alpitranslate.pipe';

@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html',
  styleUrls: ['./error404.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, LocalizeRouterModule, AlpitranslatePipe]
})
export class Error404Component implements OnInit {
  mail: string;
  productname: string;
  private loaderMap = {
    de: () => import('./translations/de').then(t => t.translations),
    fr: () => import('./translations/fr').then(t => t.translations),
    it: () => import('./translations/it').then(t => t.translations),
    nl: () => import('./translations/nl').then(t => t.translations),
    es: () => import('./translations/es').then(t => t.translations),
    cs: () => import('./translations/cs').then(t => t.translations),
    sk: () => import('./translations/sk').then(t => t.translations),
    da: () => import('./translations/da').then(t => t.translations),
    pl: () => import('./translations/pl').then(t => t.translations),
    en: () => import('./translations/en').then(t => t.translations)
  };

  constructor(
    private platformService: PlatformInformationService,
    private cdr: ChangeDetectorRef,
    private translateService: TranslateService,
    private destroyRef: DestroyRef,
    @Optional() @Inject(RESPONSE_INIT) private response: ResponseInit
  ) {}

  ngOnInit() {
    this.translateService.onLangChange
      .pipe(takeUntilDestroyed(this.destroyRef), startWith({ lang: this.translateService.currentLang }))
      .subscribe(event => {
        this.setTranslationsFor(event.lang);
      });
    this.platformService.data$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      this.mail = data.info_email;
      this.productname = data.productName;
      this.cdr.markForCheck();
    });
    if (!this.platformService.getIsBrowser()) {
      this.response.status = 404;
    }
  }

  /**
   * uses import to fetch translations on demand, add them to our translationservice
   * and updates the templates for us
   * @param lang the language you want to load translations for
   */
  private async setTranslationsFor(lang: string) {
    const translations = await this.loaderMap[lang]();
    this.translateService.setTranslation(lang, translations, true);
    this.cdr.markForCheck();
  }
}
